import React from 'react';
import { HeadSection } from 'components/HeadSection';
import { t } from '../../../../i18n';

import { ProductListWithFilter } from 'modules/search-page/desktop';

const Provider: React.FC = () => {
  return (
    <>
      <HeadSection title={t('Cửa hàng')} />
      {<ProductListWithFilter />}
    </>
  );
};

export default Provider;
